<template>
  <div class="page-template add-page order-add-page">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain v-show="formModel.reviewerStatus !==10">刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit(3)" type="primary" plain :disabled="formModel.reviewerStatus === null">审核</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form ref="listOperationForm" v-show="complexShow" :formOptions="listFormOptions"
                         @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good">选择商品</el-button>
      <!--<el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <!--<el-button @click="importData" type="primary" plain>导入商品</el-button>-->
      <el-button @click="openImport" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800" :close-on-click-modal="false">
      <good-list ref="goodsListOperation"
                 v-if="listShow"
                 @rowCheck="rowCheck"
                 :isSelect="goodListSelect"
                 :tableOptions="tableOptions"
                 @selectSubmit="rowsSelectSubmit"
                 :otherParam="otherParam"
                 :selectUrl="selectUrl"
                 :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow"
                       @importFile="importData" @downTemplate="downloadTemplate"></import-template>
    </el-dialog>
  </div>
</template>
<script>
  // 商品列表组件
  import goodList from '@/components/business/goodList';
  // 表单单组件
  import listOperationNew from "@/components/template/listOperationNew";
  // 要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  // 导入模版组件
  import importTemplate from '@/components/business/importTemplate';

  export default {
    mixins: [userPower],
    components: {
      listOperationNew,
      goodList,
      listOperationForm,
      importTemplate
    },
    data() {
      return {
        copyParams: {},
        importShow: false,
        isCheck: false,
        complexShow: true,
        goodsTxt: "",
        listTableData: [],
        goodListSelect: false,
        formModel: {reviewerStatus: null},
        title: '',
        listShow: false,
        goodList: [],
        dialogShow: false,
        isSelectSupplier: true,
        isSelectWarehouse: true,
        isClearTableData: true,
        selectUrl: {url: api.warehouse.warehouseGoods},
        otherParam: {statusList: [10, 20], isOpenCombination: 2},
        // 头部条件
        listFormOptions: {
          labelWidth: '130px',
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            }
          },
          columns: [
            {
              prop: 'id',
              hidden: true
            },
            {
              prop: 'storageId',
              hidden: true
            },
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              span: 8,
              disabled: true
            },
            {
              label: '采购门店',
              type: 'storeInputDialog',
              prop: 'storeId',
              data: [],
              span: 8,
              // url: api.purchase.purchaseStoreList,
              // url: api.store.store,
              isHasAll: true, // 下拉选择添加‘总部’字段
              disabled: false,
              change: this.purchaseStoreChange
            },
            {
              label: '供应商',
              type: 'supplierInputDialog',
              prop: 'supplierId',
              data: [],
              span: 8,
              // url: api.archives.supplier,
              change: this.supplierChange,
              isEditSupplier: false,
              disabled: false,
              param: {type: 10}
            },
            {
              label: '仓库',
              type: 'warehouseInputDialog',
              prop: 'warehouseId',
              change: this.warehouseChange,
              disabled: false,
              // url: api.warehouse.warehouse,
              data: [],
              span: 8
            },
            {
              label: '经手人',
              prop: 'handler',
              maxLength: 16,
              type: 'input',
              span: 8
            },
            {
              label: '采购入库单',
              type: 'orderDialog',
              prop: 'storageOrderNo',
              data: [],
              labelKey: 'orderNo',
              uniqueKey: 'orderNo',
              change: this.storageOrderNoChange,
              url: api.purchase.purchaseReceipt,
              columns: [
                {label: "单号", prop: "orderNo", align: "center"},
                {label: "金额", prop: "orderAmt", align: "center"},
                {label: "数量", prop: "goodsNum", align: "center"}
              ],
              span: 8
            },
            {
              label: '备注',
              type: 'input',
              maxLength: 16,
              prop: 'remarks',
              span: 8
            }
          ]
        },
        goodsCopyList: [],
        // 添加表格字段
        listColumns: {
          height: this.height,
          summaryColumns: ['goodsNum', 'salesAmount', 'totalPrice', 'giveGoodsNum', 'price'],
          columns: [
            {label: '操作', type: 'operation', width: 100, prop: 'operation'},
            {label: '序号', type: 'index', width: 60, prop: 'idx'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'input',
              width: '150',
            },
            {
              label: '商品名称',
              prop: 'name',
              width: '90'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '60'
            },
            {
              label: '单位',
              width: '60',
              prop: 'unitName'
            },
            {
              label: '自编码',
              width: '90',
              prop: 'artNo'
            },

            // {
            //   label: '档案进价',
            //   width: '90',
            //   prop: 'buyPrice',
            // },
            {
              label: '数量',
              width: '160',
              prop: 'goodsNum',
              type: 'inputNumber',
              change: this.inventoryCompare,
              precision: 3
            },
            {
              label: '赠送数量',
              width: '90',
              prop: 'giveGoodsNum',
              type: 'inputNumber',
              max: 9999.999,
              change: this.changeGiveNum,
              precision: 3
            },
            {
              label: '进价',
              width: '90',
              prop: 'price',
              type: 'inputNumber',
              precision: 3,
              change: this.priceChange
            },
            {
              label: '小计金额',
              width: '90',
              prop: 'totalPrice',
              type: 'inputNumber',
              change: this.totalPriceChange,
              precision: 3
            },
            {
              label: '零售价',
              width: '120',
              prop: 'retailPrice'
            },
            {
              label: '零售金额',
              width: '90',
              prop: 'salesAmount'
            },
            {
              label: '系统库存',
              width: '90',
              prop: 'inventoryNum'
            },
            {
              label: '备注',
              type: 'input',
              maxLength: 16,
              prop: 'remarks',
              width: '200'
            },

          ]
        },
        // 商品表格信息配置
        tableOptions: {
          indexShow: true, // 是否显示索引
          indexMethod: (index) => {
            // 自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '200',
              align: 'center'
            },
            {
              label: '品名',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '200',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '150',
              align: 'center'
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '150',
              align: 'center'
            },
            {
              label: '库存',
              prop: 'inventoryNum',
              width: '150',
              align: 'center'
            }
          ],
          param: this.otherParam,
          url: api.archives.goodsInfoIncludeSpecs
        },
        checkIndex: '',
        supplierInfo: {},
        settingInfo: {}
      };
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.title = (this.$route.query.id ? '编辑' : '新增') + document.title;
      if (this.$route.query.id) {
        this.getDetail();
      } else {
        this.$nextTick(() => {
          this.$refs.listOperationForm.formModel.warehouseId = this.$utils.getSysUser().warehouseId;
          this.isSelectWarehouse = false;
          this.copyParams.warehouseId = this.$utils.getSysUser().warehouseId;
          this.listFormOptions.columns.filter(item => item.prop === "storageOrderNo")[0].params = this.copyParams;
        })
      }
      this.getSettingStatus();
      this.setStoreId(this.listFormOptions.columns);
      this.getStoreList();
    },
    methods: {
      complexFunc() {
        if (!this.isCheck) {
          this.complexShow = !this.complexShow;
        }
      },
      listFormValueChange(value, column) {
        if (column.prop === "storeId") {
          this.listFormOptions.columns.filter(
            item => item.prop === "supplierId"
          )[0].params = {storeId: value.id};
          this.listFormOptions.columns.filter(
            item => item.prop === "warehouseId"
          )[0].params = {storeId: value.id};
          this.listFormOptions.columns.filter(
            item => item.prop === "storageOrderNo"
          )[0].params = {storeId: value.id};
        }

        if (column.prop === "storeId") {
          this.otherParam.storeId = value.id;
          this.copyParams.storeId = value.id;
          this.$refs.listOperationForm.$refs.supplierInputDialog[0].initData();
          // this.$refs.listOperationForm.$refs.warehouseInputDialog[0].initData();
          this.$refs.listOperationForm.$refs.orderDialog[0].initData();
          this.$refs.listOperationForm.formModel.supplierId = "";
          this.$refs.listOperationForm.formModel.storageOrderNo = "";
          this.$refs.listOperationForm.formModel.storeId = value.id;
          if (value.warehouseId) {
            this.$refs.listOperationForm.formModel.warehouseId = value.warehouseId;
            this.otherParam.warehouseId = value.warehouseId;
            this.copyParams.warehouseId = value.warehouseId;
            this.isSelectWarehouse = false;
          }
          this.listFormOptions.columns.filter(item => item.prop === "storageOrderNo")[0].params = this.copyParams;
        } else if (column.prop === "supplierId") {
          this.otherParam.supplierId = value;
          this.isSelectSupplier = false;
          this.copyParams.supplierId = value;
          this.listFormOptions.columns.filter(item => item.prop === "storageOrderNo")[0].params = this.copyParams;
          this.$refs.listOperationForm.$refs.orderDialog[0].initData();
          this.$refs.listOperationForm.formModel.storageOrderNo = "";
        } else if (column.prop === "warehouseId") {
          this.otherParam.warehouseId = value;
          this.isSelectWarehouse = false;
          this.copyParams.warehouseId = value;
          this.listFormOptions.columns.filter(item => item.prop === "storageOrderNo")[0].params = this.copyParams;
          this.$refs.listOperationForm.$refs.orderDialog[0].initData();
          this.$refs.listOperationForm.formModel.storageOrderNo = "";
        }
        this.$refs['listOperation'].clearTableData();
        if (column.prop === "storageOrderNo") {
          this.storageOrderNoChange(value);
        }
      },
      search() {
        if (this.goodsTxt === '' || this.goodsTxt === null) return;
        this.otherParam.otherName = this.goodsTxt;
        if (!this.settingInfo.supplierGoods) {
          this.supplierInfo.supplierId = "";
        }
        this.otherParam = {...this.otherParam, ...this.supplierInfo};
        if (this.isSelectSupplier) {
          this.goodsTxt = ''
          this.$confirm("请选择供应商！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          if (this.isSelectWarehouse) {
            this.goodsTxt = ''
            this.$confirm("请选择仓库！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            });
          } else {
            this.isCheck = true;
            this.$axios
              .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
              .then(res => {
                if (res.code === 200) {
                  if (res.data.length > 0) {
                    let tableData = res.data;
                    if (tableData.length === 1) {
                      let row = tableData[0];
                      let tableList = this.$refs["listOperation"].getTabelData();
                      let flag = true;
                      if (tableList.length > 0) {
                        tableList.forEach(item => {
                          if (flag) {
                            if (item.barCode === row.barCode) flag = false;
                          }
                        });
                      }
                      if (!flag) {
                        this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                        return;
                      }
                      row.name = row.goodsName;
                      row.goodsNum = 0.0.toFixed(3); // 数量
                      row.giveGoodsNum = 0.0.toFixed(3); // 赠送数量
                      row.salesAmount = 0.0.toFixed(2); // 销售金额
                      row.price = row.buyPrice; // 价格
                      row.totalPrice = 0.0.toFixed(2); // 小计金额
                      row.isFinalNum = 1;
                      row.remarks = null;
                      // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                      this.$refs["listOperation"].setColumnData(row, tableList.length);
                      this.currentTableList = this.$refs["listOperation"].getTabelData();
                      this.$message.success("商品添加成功");
                    } else {
                      this.queryGoodsList();
                    }
                  } else {
                    this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
                  }
                } else {
                  this.$message({type: "error", message: res.msg});
                }
              })
              .catch(err => {
              }).finally(() => {
              this.isCheck = false;
              this.clearQueryParam();
            });
          }
        }
      },
      clearQueryParam() {
        this.goodsTxt = '';
        this.otherParam.otherName = '';
      },
      queryGoodsList() {
        this.listShow = true;
        this.goodListSelect = true;
        this.listTableData = this.$refs["listOperation"].getTabelData(); // table数据  原始的
        if (!this.settingInfo.supplierGoods) {
          this.supplierInfo.supplierId = "";
        }
        this.$nextTick(() => {
          this.otherParam = {...this.otherParam, ...this.supplierInfo};
        });
      },
      getStoreList() {
        let user = this.$utils.getSysUser();
        if (user.storeId) {
          this.$axios.fetchPost(api.store.store + '/list', {}).then(data => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].data = data.data;
            } else {
              this.$message({message: '获取采购门店失败!', type: 'error'});
            }
          });
        } else {
          this.$axios.fetchPost(api.purchase.purchaseStoreList + '/list', {}).then(data => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].data = data.data;
              data.data.unshift({id: -1, name: '总部'});
            } else {
              this.$message({message: '获取采购门店失败!', type: 'error'});
            }
          });
        }
      },
      // 获取设置状态
      getSettingStatus() {
        // 获取设置信息 接口
        this.$axios.fetchGet(api.purchase.pcPurchaseDefaultInfo, {}).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.settingInfo = res.data
            }
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
        })
      },
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.purchase.return + '?id=' + this.$route.query.id, {})
          .then((data) => {
            this.formModel.reviewerStatus = data.data.reviewerStatus
            this.loading = false;
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].isEditSupplier = true;
              data.data.goodsMapList.map((item) => {
                item.name = item.goodsName;
              });
              // 审核的时候需要对数量进行校验
              this.goodsCopyList = this.$utils.deepClone(data.data.goodsMapList);
              this.goodsCopyList.map((item) => {
                item.goodsNum = item.goodsNum + item.noStorageNum;
                item.isFinalNum = 1;
              });
              this.$nextTick(() => {
                // 为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                this.purchaseStoreChange({storeId: data.data.storeId})
                this.supplierInfo.storeId = data.data.storeId;// 门店id
                this.otherParam.storeId = data.data.storeId;// 门店id,barcode查询需要的参数
                this.isSelectSupplier = false;
                this.isSelectWarehouse = false;
                this.isClearTableData = false;
                // 为表格赋值
                this.$refs['listOperation'].addMoreRow(data.data.goodsMapList, 0);
                this.currentTableList = this.$refs['listOperation'].getTabelData();
                this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
                this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].disabled = true;
                this.listFormOptions.columns.filter(item => item.prop === 'warehouseId')[0].disabled = true;
                this.listFormOptions.columns.filter(item => item.prop === 'handler')[0].disabled = true;
                this.listFormOptions.columns.filter(item => item.prop === 'storageOrderNo')[0].disabled = true;
              });
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },
      refresh() {
        if (!this.isCheck) {
          this.$router.go(0);
        }
      },
      audit(e) {
        if (!this.isCheck) {
          this.submitAuth(e);
        }
      },
      checkGoods() {
        if (!this.isCheck) {
          if (this.isSelectSupplier) {
            this.$confirm('请选择供应商！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } else {
            if (this.isSelectWarehouse) {
              this.$confirm('请选择仓库！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            } else {
              this.listShow = true;
              this.goodListSelect = true;
              this.listTableData = this.$refs['listOperation'].getTabelData()// table数据
              if (!this.settingInfo.supplierGoods) {
                this.supplierInfo.supplierId = ''
              }
              this.$nextTick(() => {
                this.otherParam = {...this.otherParam, ...this.supplierInfo};
              })
            }
          }
        }
      },
      supplierChange(data) {
        let editSupplier = this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].isEditSupplier;
        if (editSupplier === false) {
          if (data.supplierId) {
            this.isSelectSupplier = false;
            this.getStorageOrderNo(data);
            this.$refs['listOperation'].clearTableData();
            this.supplierInfo.supplierId = data.supplierId;
          } else {
            this.isSelectSupplier = true;
          }
        } else {
          this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].isEditSupplier = false;
        }
      },
      // 多选 商品 确认
      rowsSelectSubmit(rows) {
        rows.map((item) => {
          item.name = item.goodsName;
          item.goodsNum = 0.0.toFixed(3); // 数量
          item.giveGoodsNum = 0.0.toFixed(3); // 赠送数量
          item.salesAmount = 0.0.toFixed(2); // 销售金额
          item.price = item.buyPrice; // 价格
          item.totalPrice = 0.0.toFixed(2); // 小计金额
          item.isFinalNum = 1;
          item.remarks = null;
        });
        this.listShow = false;
        let tableList = this.$refs['listOperation'].getTabelData();
        this.$refs['listOperation'].addMoreRow(rows, tableList.length);
        this.currentTableList = this.$refs['listOperation'].getTabelData();
        if (rows && rows.length > 0) {
          this.$message.success("商品添加成功");
        }
      },
      // 输入数量
      inventoryCompare(row, index) {
        if (row.goodsNum && row.goodsNum >= 9999.999) {
          row.goodsNum = '9999.999'.toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.goodsNum === '' || row.goodsNum == null) {
          row.goodsNum = rowData.goodsNum.toString();
          row.price = rowData.price.toString();
          row.totalPrice = rowData.totalPrice.toString();
          return;
        }
        if (Number(row.goodsNum) - Number(row.goodsNumOld) > 0) {
          // this.$message.warning('退货数量大于原单入库数量，请重新修改')
          this.$alert('退货数量大于原单入库数量，请重新修改', '提示', {
            confirmButtonText: '确定',
            callback: () => {
            }
          });
          row.goodsNum = row.goodsNumOld
        } else {
          // 后端通过这个判断是否是部分退货
          row.noStorageNum = row.goodsNumOld - row.goodsNum;
          row.isFinalNum = 0;
          this.updateData(row, index);
        }
        // if (row.inventoryNum - row.goodsNum < 0) {
        //   // 退货数量大于原单入库数量，请修改
        //   this.$confirm(row.name + '：原单入库数量为{' + row.inventoryNum + '}不足以本次出库，是否继续更改?', '提示',
        //     {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'warning',
        //     }
        //   ).then(() => {
        //     this.numChange(row, index);
        //   }).catch(() => {
        //     row.goodsNum = row.inventoryNum;
        //     this.numChange(row, index);
        //   })
        // } else {
        //   this.numChange(row, index);
        // }
      },
      numChange(row, index) {
        if (this.goodsCopyList.length !== 0) {
          this.goodsCopyList.map((item) => {
            if (item.barCode === row.barCode) {
              if (row.goodsNum > item.goodsNum) {
                this.$confirm(
                  row.name +
                  '：实际入库的剩余数量为' +
                  item.goodsNum +
                  '多余部分请重新制定入库单！',
                  '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }
                )
                  .then(() => {
                    row.isFinalNum = 1;
                    row.goodsNum = item.goodsNum;
                    this.updateData(row, index);
                  })
                  .catch(() => {
                    row.isFinalNum = 1;
                    row.goodsNum = item.goodsNum;
                    this.updateData(row, index);
                  });
              } else if (row.goodsNum < item.goodsNum) {
                // 后端通过这个判断是否是部分退货
                row.noStorageNum = item.goodsNum - row.goodsNum;
                row.isFinalNum = 0;
                this.updateData(row, index);
              }
            }
          });
          row.isFinalNum = 1;
          this.updateData(row, index);
        } else {
          row.isFinalNum = 1;
          this.updateData(row, index);
        }
      },
      totalPriceChange(row, index) {
        // if (row.totalPrice !== null && row.totalPrice !== '' && row.goodsNum !== null && row.goodsNum !== '' && row.goodsNum !== 0) {
        //   row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
        // }
        if (row.totalPrice && row.totalPrice >= 99999.999) {
          row.totalPrice = '99999.999'.toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.totalPrice !== null && row.totalPrice !== '' && row.totalPrice !== undefined) {
          if (row.goodsNum !== null && row.goodsNum !== '' && row.goodsNum !== 0) {
            row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
            if ((row.price).toString() && rowData.buyPrice) {
              if (Number(row.price) > Number(row.buyPrice) && this.settingInfo.greaterGoodsPrice) {
                this.$confirm('当前进价大于商品档案进价，确认？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
                }).catch(() => {
                  row.price = rowData.price
                })
              } else {
                row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
              }
            }
          } else {
            row.totalPrice = rowData.totalPrice.toString();
          }

        } else {
          if ((row.totalPrice == null || row.totalPrice === '' || row.totalPrice === undefined) &&
            (row.goodsNum === null || row.goodsNum === '' || row.goodsNum === 0)) {
            row.goodsNum = rowData.goodsNum.toString();
            row.price = rowData.price.toString();
            row.totalPrice = rowData.totalPrice.toString();
          } else {
            row.totalPrice = rowData.totalPrice.toString();
            row.price = '0.00';
          }
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      updateData(row, index) {
        if (row.retailPrice) {
          row.salesAmount = parseFloat(row.retailPrice * row.goodsNum).toFixed(2);
        }
        if (row.price) {
          row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      changeGiveNum(row, index) {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.giveGoodsNum === '' || row.giveGoodsNum == null) {
          row.giveGoodsNum = rowData.giveGoodsNum.toString();
          return;
        }
        if (this.goodsCopyList.length !== 0) {
          this.goodsCopyList.map((item) => {
            if (item.barCode === row.barCode) {
              if (row.giveGoodsNum > item.giveGoodsNum) {
                this.$confirm(row.name + ':入库时的赠送数量为' + item.giveGoodsNum + '确定要进行更改？', '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).catch(() => {
                  row.giveGoodsNum = item.giveGoodsNum;
                  this.$refs['listOperation'].setCountData(row, index);
                })
              }
            }
          })
        }
      },
      // 输入商品价格
      priceChange(row, index) {
        if (row.price && row.price >= 99999.999) {
          row.price = '9999.999'.toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.price == null || row.price === '') {
          row.price = rowData.price.toString();
        }
        if ((row.price).toFixed(2) && row.buyPrice) {
          if (Number(row.price) > Number(row.buyPrice) && this.settingInfo.greaterGoodsPrice) {
            this.$confirm('当前进价大于商品档案进价，确认？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
              this.$refs['listOperation'].setCountData(row, index);
            }).catch(() => {
              row.price = rowData.price
            })
          } else {
            row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
            this.$refs['listOperation'].setCountData(row, index);
          }
        }
      },
      // 选择某行数据
      rowCheck(row) {
        this.listShow = false;
        row.goodsNum = 0.0.toFixed(3); // 数量
        row.giveGoodsNum = 0.0.toFixed(3); // 赠送数量
        row.salesAmount = 0.0.toFixed(2); // 销售金额
        row.price = row.buyPrice; // 价格
        row.totalPrice = 0.0.toFixed(2); // 小计金额
        row.isFinalNum = 1; // 是否是商品最终入库数量
        row.name = row.goodsName;
        row.remarks = null;
        this.$refs['listOperation'].setColumnData(row, this.checkIndex);
        this.currentTableList = this.$refs['listOperation'].getTabelData();
      },
      // 提交数据
      submitAuth(e) {
        if (!this.isCheck) {
          // 将商品list的值重新赋值给后端接收的参数
          let tableList = this.$refs['listOperation'].getTabelData();
          let orderNumber = 1;
          tableList.map(item => {
            item.orderNumber = orderNumber++;
            item.goodsId = item.goodsId || item.id;
            item.type = 30;
          });
          // 将合计的值重新赋值给后端接收的参数
          let totalParam = this.$refs['listOperation'].getSumData();
          totalParam.billAmt = totalParam.totalPrice;
          // 将表头的值重新赋值给后端接收的参数
          let headParam = this.$refs.listOperationForm.getFormModel();
          headParam.reviewerStatus = 20;
          let searchParam = {
            ...{goodsMapList: tableList},
            ...totalParam,
            ...headParam
          };
          if (headParam.warehouseId === undefined) {
            this.$confirm('请选择仓库！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } else if (tableList.length === 0) {
            this.$message({message: '商品信息无效！', type: 'warning'});
          } else {
            let testSave = false
            testSave = tableList.every(v => {
              if (v.goodsName && v.barCode) {
                return true
              } else {
                return false
              }
            })
            let length = 0;
            let priceLength = 0;
            tableList.map(table => {
              // if (table.goodsNum === 0) {
              if ((table.giveGoodsNum + table.goodsNum) <= 0) {
                length = length + 1;
              }
              if (table.price <= 0) {
                priceLength = priceLength + 1;
              }
            });
            let priceFlag = false
            let mountFlag = false
            tableList.map(item => {
              for (let key in item) {
                if (this.validePirce(key)) {
                  if (item[key] > 99999.99) {
                    priceFlag = true
                  }
                }
                if (this.valideMount(key)) {
                  if (item[key] > 9999.999) {
                    mountFlag = true
                  }
                }
              }
            })
            if (mountFlag) return this.$message.warning('数量相关不能超过9999.999')
            if (priceFlag) return this.$message.warning('价格不能超过99999.99')
            if (testSave) {
              if (length > 0) {
                this.$message({message: '存在数量为0的商品，不能进行保存/审核！', type: 'warning'});
              } else {
                if (priceLength > 0) {
                  this.$confirm('存在进价为0的商品,是否继续保存/审核?', '提示',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }
                  ).then(() => {
                    this.saveData(headParam, e, searchParam);
                  });
                } else {
                  this.saveData(headParam, e, searchParam);
                }
              }
            }
          }
        }
      },
      validePirce(val) {
        const priceArray = ['buyPrice', 'deliveryPrice', 'lowestPrice', 'plusVipPrice', 'retailPrice', 'tradePrice', 'vipPrice'];
        if (priceArray.includes(val)) {
          return true
        } else {
          return false
        }
      },
      valideMount(val) {
        const mountArray = ['giveGoodsNum', 'goodsNum', 'inventoryNum'];
        if (mountArray.includes(val)) {
          return true
        } else {
          return false
        }
      },
      saveData(headParam, e, searchParam) {
        if (headParam.id) {
          if (e === 3) {
            this.$confirm('是否确认审核?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              this.handleRequest(this.$axios.fetchPost(api.purchase.return + '/audit', searchParam), e);
              // this.$message({message: '审核成功！', type: 'info'})
            }).catch(() => this.$message({message: '审核取消！', type: 'info'}));
          } else {
            this.$confirm('是否确认保存?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              this.handleRequest(this.$axios.fetchPut(api.purchase.return, searchParam), e);
              // this.$message({message: '保存成功！', type: 'info'})
            }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
          }
        } else {
          this.$confirm('是否确认保存?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            this.handleRequest(this.$axios.fetchPost(api.purchase.return, searchParam), e);
            // this.$message({message: '保存成功！', type: 'info'})
          }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
        }
      },
      handleRequest(param, e) {
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        param.then((data) => {
          this.loading = false;
          if (data.code === 200) {
            if (e === 3) {
              this.$notify({
                type: "success",
                title: '审核操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '审核成功！', type: 'success'});
              this.$router.push({path: '/purchase/return'});
            } else {
              this.$notify({
                type: "success",
                title: '保存操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '保存成功！', type: 'success'});
              this.dialogShow = false;
              this.$refs.listOperationForm.formModel = data.data;
              this.formModel.reviewerStatus = data.data.reviewerStatus;
            }
          } else {
            if (e === 3) {
              this.$notify({
                type: "error",
                title: '审核操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '审核失败！' + data.code + ':' + data.errorMsg, type: 'error'});
            } else {
              this.$notify({
                type: "error",
                title: '保存操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '保存失败！' + data.code + ':' + data.errorMsg, type: 'error'});
            }
          }
        })
          .catch((err) => {
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          }).finally(() => {
          loading.close()
        })
      },

      // 获取采购单
      getStorageOrderNo(data) {
        this.$refs['listOperation'].clearTableData();
        this.$axios
          .fetchPost(api.purchase.return + '/receive/audit/complete', {
            reviewerStatus: 10,
            supplierId: data.supplierId,
            warehouseId: data.warehouseId
          })
          .then((data) => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter(
                (item) => item.prop === 'storageOrderNo'
              )[0].data = data.data;
              this.$set(this.$refs.listOperationForm.formModel, 'storageOrderNo', '');
              // this.$refs.listOperationForm.formModel.orderNo = '';
              // this.$refs.listOperationForm.formModel.id = '';
              // this.$refs.listOperationForm.formModel.storageId = '';
              // this.$refs.listOperationForm.formModel.handler = '';
              // this.$refs.listOperationForm.formModel.storageOrderNo = '';
              // this.$refs.listOperationForm.formModel.remarks = '';
              // this.$refs.listOperationForm.formModel.warehouseId = '';
            }
          });
      },
      // 引用收货单
      storageOrderNoChange(item) {
        this.$refs['listOperation'].clearTableData();
        let data = this.$refs.listOperationForm.formModel;
        data.storageId = item.id;
        data.storageOrderNo = item.orderNo;
        this.isSelectWarehouse = false;
        this.$axios
          .fetchPost(api.purchase.goods + '/return/goods/list', {
            orderNo: data.storageOrderNo, type: 20
          })
          .then((goodsData) => {
            if (goodsData.code === 200) {
              this.goodsCopyList = goodsData.data;
              goodsData.data.map((item) => {
                item.goodsNumOld = item.goodsNum
                item.id = item.goodsId;
                item.name = item.goodsName;
                item.isFinalNum = 1;
              });
              this.$refs['listOperation'].addMoreRow(goodsData.data, this.checkIndex);
              this.currentTableList = this.$refs['listOperation'].getTabelData();
            }
          });
      },
      warehouseChange(data) {
        if (this.isClearTableData) {
          this.$refs['listOperation'].clearTableData();
          this.$refs.listOperationForm.formModel.storageOrderNo = '';
          this.getStorageOrderNo(data);
        } else {
          this.isClearTableData = true;
        }
        this.supplierInfo.warehouseId = data.warehouseId;
        this.isSelectWarehouse = false;
      },
      downloadTemplate() {
        if (!this.isCheck) {
          this.$axios.fetchPost(api.purchase.templateDown + '?&downType=30').then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      },
      importData() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.supplierId) {
            if (tableData.warehouseId) {
              this.$utils.uploadFile((file) => {
                this.loading = true;
                let formData = new FormData();
                formData.append('multipartFile', file);
                formData.append('supplierId', tableData.supplierId);
                formData.append('warehouseId', tableData.warehouseId);
                formData.append('businessType', 20);
                this.$refs['listOperation'].clearTableData();
                const loading = this.$loading({
                  lock: true,
                  text: '提交中，请稍候...',
                  background: 'rgba(225, 225, 225, 0.8)'
                });
                this.$axios
                  .fetchPostGoodsExport(api.purchase.purchaseImport, formData)
                  .then(data => {
                    if (data.code === 200) {
                      //关闭导入弹窗
                      this.importShow = false;
                      // 为表格赋值
                      if (data.data.pcGoodsMapMVOList) {
                        data.data.pcGoodsMapMVOList.map((item, index) => {
                          item.id = index + 1;
                          item.salesAmount = (item.retailPrice * item.goodsNum).toFixed(2);
                          if (!item.price) {
                            item.price = item.buyPrice;
                          }
                          item.totalPrice = (item.price * item.goodsNum).toFixed(2);
                          item.name = item.goodsName;
                        });
                        this.currentTableList = data.data.pcGoodsMapMVOList;
                        this.$refs['listOperation'].addMoreRow(data.data.pcGoodsMapMVOList, 0);
                      }
                      if (data.data.errorBatchId) {
                        this.exportErrorData(data.data.errorBatchId);
                      }
                    } else {
                      if (data.errorMsg) {
                        this.$message({message: data.errorMsg, type: 'error'});
                      } else {
                        this.$notify({
                          type: "error",
                          title: '导入操作',
                          message: '失败',
                          showClose: false,
                        });
                        // this.$message({message: '导入异常', type: 'error'});
                      }
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    console.log(err);
                  }).finally(() => {
                  this.loading = false;
                  loading.close()
                });
              });
            } else {
              this.$message({message: '请选择仓库！', type: 'warning'});
            }
          } else {
            this.$message({message: '请选择供应商！', type: 'warning'});
          }
        }
      },
      // 导入的错误数据
      exportErrorData(id) {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.PostBlob(api.system.exportError + '?batchId=' + id, '').then(res => {
          if (res.status === 200) {
            const fileName = '采购退货错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },

      purchaseStoreChange(row) {
        // 通过门店id获取供应商以及仓库
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: row.storeId}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].data = data.data;
          } else {
            this.$message({message: '获取供应商失败!', type: 'error'});
          }
        });
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: row.storeId}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'warehouseId')[0].data = data.data;
            if (data.data) {
              data.data.map(item => {
                if (item.defaultState === true) {
                  row.warehouseId = item.id;
                  this.isSelectWarehouse = false;
                  this.otherParam.warehouseId = item.id;
                }
              })
            }
          } else {
            this.$message({message: '获取仓库失败!', type: 'error'});
          }
        });
        if (!this.$route.query.id) {
          this.$nextTick(() => {
            this.otherParam.storeId = row.storeId;
            this.$nextTick(() => {
              this.$refs['listOperation'].clearTableData();
              this.listFormOptions.columns.filter(item => item.prop === 'storageOrderNo')[0].data = [];
              this.$refs.listOperationForm.formModel.storageOrderNo = '';
              this.$refs.listOperationForm.formModel.supplierId = '';
              this.supplierInfo.supplierId = ''
              this.isSelectSupplier = true;
            });
          });
        }
      },
      openImport() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.supplierId) {
            if (tableData.warehouseId) {
              this.importShow = true;
            } else {
              this.$message.warning("请选择仓库")
            }
          } else {
            this.$message.warning("请选择供应商")
          }
        }
      },
    }
  };
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }
</style>



// WEBPACK FOOTER //
// src/page/purchase/ReturnAdd.vue